// extracted by mini-css-extract-plugin
module.exports = {"change-learner-password-form":"ChangeLearnerPasswordForm_change-learner-password-form__3O34B","footer":"ChangeLearnerPasswordForm_footer__e1BEZ"};